<template>
  <div class="introduction-match" >
    <div v-if="!matchList.length" >
      <div class="title" >没有可以选择的赛事</div>
      <p>没有可以选择的赛事导入球队</p>
    </div>
    <div class="main" v-if="matchList.length" >
      <div class="title" >选择赛事导入球队</div>
      <p>导入球队自动成为参赛球队,如需编辑球员信息请前往参赛球队设置</p>
      <!--
      <div style="width: 100%; height: 50px;" ></div>-->
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div
          class="player"
          v-for="item in matchList"
          :key="item.id"
          @click="routerIntroductionTeam(item.id)" >
          <div>
            <img :src="formatterImgSrc(item.icon)">
          </div>
          <div>
            <p>{{ item.chineseName || item.chineseFullName }}</p>
            <span>{{ item.approvedTeamCount }}支球队</span> <!-- 球队数量 API 暂未提供 所以暂不实现 -->
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { List, Toast } from 'vant'
import { ImageFormat } from '@/utils/'
import { getMyManageBMMatchList } from '@/api/team'
Vue.use(List).use(Toast)
export default {
  name: 'IntroductionMatch',
  data() {
    return {
      chinckIn: false,
      pageSize: 20,
      pageNum: 0,
      matchList: [],
      loading: false,
      finished: false,
      query: null,
      matchId: null
    }
  },
  created() {
    this.query = this.$route.query
    this.matchId = this.query.matchId
    if (!this.matchId) {
      Toast.loading({
        mask: true,
        message: '参数错误',
        duration: 0
      })
      return
    }
    this.getMyManageBMMatchList()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    }
  },
  methods: {
    getMyManageBMMatchList() {
      let params = {
        related: 1,
        ready: 0,
        pageSize: this.pageSize,
        pageNum: this.pageNum + 1
      }
      getMyManageBMMatchList(params).then(response => {
        let data = response.data
        data.matches = data.matches.filter(item => {
          if (item.id === this.matchId) {
            return false
          }
          return item
        })
        this.pageNum = data.pageNum
        this.matchList = this.matchList.concat(data.matches)
        this.loading = false
        if (data.matches.length < this.pageSize) {
          this.finished = true
        }
      })
    },
    onLoad() {
      this.getMyManageBMMatchList()
    },
    routerIntroductionTeam(oldMatchId) {
      this.$router.push({
        path: '/introduction/team',
        query: {
          matchId: this.matchId,
          oldMatchId: oldMatchId
        }
      })
    }
  }
}
</script>
<style lang="stylus" >
  .introduction-match
    height 100%
    overflow-y scroll
    .title
      font-size: 30px;
      font-weight: 400;
      color: rgba(0,0,0,1);
      padding: 10px 15px;
      span
        text-align right
        float right
    .title+p
      font-size:16px;
      font-weight:300;
      color:rgba(0,0,0,1);
      padding: 0 15px
      margin-top 0
  .player
    display flex
    padding 15px
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:last-child
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      span
        font-size:12px;
        font-weight:400;
        color:rgba(129,129,129,1);
</style>



// WEBPACK FOOTER //
// src/pages/introduction/match.vue